export default "__VITE_ASSET__B5l8vOW___"